import AppContext from '@/types/context'
import Gallery from '@/elements/widgets/Gallery/Gallery'
import styles from './GalleryInline.module.scss'

const GalleryInline = ({ item, context }: { item: any; context: AppContext }) => {
  const gallery = item.items?.filter((child: any) => child.type === 'gallery')[0]

  if (!item?.items || !gallery) {
    return null
  }

  return (
    <div className={styles.container}>
      <Gallery item={item} context={context} variant="inline" />
    </div>
  )
}

export default GalleryInline
